import { Fragment, ReactNode } from 'react';
import { Badge, Box, PopoverRoot, PopoverTrigger, PopoverPopup, Stack } from '@ff-it/ui';
import { listItem, more, moreContainer } from './TruncatedList.css';

interface TruncatedListProps<T> {
  items: T[];
  limit?: number;
  renderItem: (item: T, index: number) => ReactNode;
  getKey: (item: T) => string | number;
  moreLabel?: (count: number) => string;
}

export function TruncatedList<T>({ items, limit = 5, renderItem, getKey }: TruncatedListProps<T>): ReactNode {
  const visibleItems = items.slice(0, limit);
  const remainingItems = items.slice(limit);

  return (
    <Stack direction="horizontal" align="center">
      {visibleItems.map((item, index) => (
        <Box key={getKey(item)} className={listItem}>
          {renderItem(item, index)}
        </Box>
      ))}
      {remainingItems.length > 0 && (
        <PopoverRoot>
          <PopoverTrigger openOnHover>
            <Box cursor="pointer" className={more} role="button" aria-label={`${remainingItems.length} more items`}>
              <Badge count={`+${remainingItems.length}`} />
            </Box>
          </PopoverTrigger>
          <PopoverPopup>
            <Stack direction="vertical" p="3" className={moreContainer}>
              {remainingItems.map((item, index) => (
                <Fragment key={getKey(item)}>{renderItem(item, limit + index)}</Fragment>
              ))}
            </Stack>
          </PopoverPopup>
        </PopoverRoot>
      )}
    </Stack>
  );
}
